// extracted by mini-css-extract-plugin
export var ageGenderWrapper = "Form-module--ageGenderWrapper--o3tld";
export var bothFormsWrapper = "Form-module--bothFormsWrapper--wEAYS";
export var btn = "Form-module--btn--1o6Ys";
export var btnAndInvalidLogIntextWrapper = "Form-module--btnAndInvalidLogIntextWrapper--DJ+BM";
export var changePassHeadingWrapper = "Form-module--changePassHeadingWrapper--4FD99";
export var changePassLoader = "Form-module--changePassLoader--NOGp-";
export var changePassLoaderAnimation = "Form-module--changePassLoaderAnimation--EWJV1";
export var changePassTitle = "Form-module--changePassTitle--9XKBY";
export var changePassWrapper = "Form-module--changePassWrapper--veEbr";
export var childButtonWrapper = "Form-module--childButtonWrapper--demqn";
export var childForm = "Form-module--childForm--YZRP6";
export var childInputControlls = "Form-module--childInputControlls--gzUr1";
export var childText = "Form-module--childText--P1JQZ";
export var crossBtn = "Form-module--crossBtn--DdkZf";
export var forgottenBtn = "Form-module--forgottenBtn--gk6XA";
export var forgottenBtnMargin = "Form-module--forgottenBtnMargin--hYkb0";
export var inputSpan = "Form-module--inputSpan--TXTFr";
export var inputText = "Form-module--inputText--UE9x2";
export var inputTextDate = "Form-module--inputTextDate--N5TUk";
export var inputiconWrapper = "Form-module--inputiconWrapper--fuL0n";
export var inputiconWrapperPass = "Form-module--inputiconWrapperPass--c9Jaa";
export var inputiconWrapperTwo = "Form-module--inputiconWrapperTwo--Ny4kh";
export var inputiconWrapperUser = "Form-module--inputiconWrapperUser--uH7Iy";
export var invalidInputSpan = "Form-module--invalidInputSpan--+oWF9";
export var invalidText = "Form-module--invalidText--CY2kZ";
export var invalidTextWrapper = "Form-module--invalidTextWrapper--797Rv";
export var logInButtonWrapper = "Form-module--logInButtonWrapper--5Khxy";
export var logInTextServerError = "Form-module--logInTextServerError--+PkcK";
export var mainForm = "Form-module--mainForm--yE5L0";
export var maxChildrenwarning = "Form-module--maxChildrenwarning--vsJBQ";
export var passwordChangedText = "Form-module--passwordChangedText--+Prqg";
export var plusBtn = "Form-module--plusBtn--vdjUQ";
export var signInTitle = "Form-module--signInTitle--hn5dT";
export var sucRegText = "Form-module--sucRegText--FUICW";
export var termsAndConditionsControl = "Form-module--termsAndConditionsControl--cEESI";
export var termsPopUpBtn = "Form-module--termsPopUpBtn--LSvGm";
export var termsText = "Form-module--termsText--vn0xt";
export var termsTextInvalid = "Form-module--termsTextInvalid--RBrpN";
export var visBtn = "Form-module--visBtn--KjzKD";